export default "<app-content-container>\n  <div>\n    <app-task-accordion></app-task-accordion>\n  </div>\n</app-content-container>\n"